import React from 'react';
import { BsX, BsCameraVideoFill, BsFileText, BsExclamationTriangleFill, BsPersonX, BsPlayCircle, BsCheckCircle } from 'react-icons/bs';

interface HelpDrawerVincularProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const Section: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <div style={{ marginBottom: '20px' }}>
    <h4 style={{ fontSize: '14px', fontWeight: '600', color: '#333', marginBottom: '8px', borderBottom: '1px solid #eee', paddingBottom: '6px' }}>
      {title}
    </h4>
    <div style={{ fontSize: '13px', color: '#555', lineHeight: '1.6' }}>{children}</div>
  </div>
);

const DRAWER_WIDTH = 320;

const HelpDrawerVincular: React.FC<HelpDrawerVincularProps> = ({ isOpen, onClose, children }) => {
  return (
    <>
      <div style={{ marginRight: isOpen ? DRAWER_WIDTH : 0, transition: 'margin-right 0.3s ease' }}>
        {children}
      </div>

      <div style={{
        position: 'fixed',
        top: 0,
        right: isOpen ? 0 : -DRAWER_WIDTH,
        width: DRAWER_WIDTH,
        height: '100vh',
        backgroundColor: '#fff',
        borderLeft: '1px solid #e0e0e0',
        boxShadow: '-2px 0 8px rgba(0,0,0,0.08)',
        transition: 'right 0.3s ease',
        zIndex: 1050,
        display: 'flex',
        flexDirection: 'column',
      }}>
        <div style={{
          padding: '12px 16px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          background: 'linear-gradient(180deg, #2a2d3a 0%, #3c3f4c 100%)',
          color: '#fff',
        }}>
          <h3 style={{ margin: 0, fontSize: '14px', fontWeight: '600' }}>Ajuda — Vincular Candidatos</h3>
          <button
            onClick={onClose}
            style={{ background: 'transparent', border: 'none', color: '#fff', fontSize: '18px', cursor: 'pointer', padding: '0 4px' }}
          >
            <BsX />
          </button>
        </div>

        <div style={{ flex: 1, overflowY: 'auto', padding: '16px', fontSize: '13px' }}>
          <Section title="Objetivo">
            <p style={{ margin: 0 }}>Esta página permite vincular candidatos a uma banca específica para heteroidentificação.</p>
          </Section>

          <Section title="Restrições por Tipo de Banca">
            <ul style={{ margin: 0, paddingLeft: '18px' }}>
              <li><strong>Banca Facial:</strong> Apenas candidatos com status NAO_AVALIADO</li>
              <li><strong>Banca Virtual:</strong> Apenas candidatos com status NAO_AVALIADO, INCONCLUSIVO ou AUSENTE</li>
              <li><strong>Banca Recursal:</strong> Apenas candidatos com status NÃO VALIDADO e que possuam vídeo enviado</li>
            </ul>
          </Section>

          <Section title="Filtros Disponíveis">
            <ul style={{ margin: 0, paddingLeft: '18px' }}>
              <li>Nome</li>
              <li>Nome Social</li>
              <li>Inscrição</li>
              <li>Status</li>
              <li>Recurso (com/sem)</li>
              <li>Apenas candidatos com editais em comum</li>
            </ul>
          </Section>

          <Section title="Ordenação">
            <p style={{ margin: '0 0 6px 0' }}>Os candidatos não vinculados são ordenados por:</p>
            <ol style={{ margin: 0, paddingLeft: '18px' }}>
              <li>Candidatos ausentes aparecem por último</li>
              <li>Candidatos com recurso aparecem primeiro</li>
              <li>Candidatos com edital em comum</li>
              <li>Ordem alfabética por nome</li>
            </ol>
          </Section>

          <Section title="Ícones">
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <BsCameraVideoFill className="text-dark" /> <span>Candidato com recurso</span>
              </div>
              <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <BsFileText className="text-success" /> <span>Candidato com edital em comum</span>
              </div>
              <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <BsExclamationTriangleFill className="text-danger" /> <span>Candidato SEM edital em comum</span>
              </div>
              <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <BsPersonX className="text-danger" /> <span>Candidato ausente</span>
              </div>
              <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <BsPlayCircle className="text-info" /> <span>Heteroidentificação aberta</span>
              </div>
              <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <BsCheckCircle className="text-success" /> <span>Heteroidentificação fechada</span>
              </div>
            </div>
          </Section>
        </div>
      </div>
    </>
  );
};

export default HelpDrawerVincular;
